import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LionsStripe from '../components/LionsStripe';
import { ArrowTopRightOnSquareIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const PORTAL_URL = 'https://www.schoolsaccount.nyc/';

const ParentPortalPage = () => {
  return (
    <div className="min-h-screen bg-accent-light font-sans selection:bg-secondary selection:text-white">
      <Navbar />

      <main id="main-content">
        {/* ============================================================================
            HERO SECTION
        ============================================================================ */}
        <section className="relative pt-32 pb-20 min-h-screen flex items-center justify-center overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-br from-primary via-navy-900 to-primary"></div>
            <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay"></div>
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[100px]"></div>
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-[100px]"></div>
          </div>

          <div className="max-w-3xl mx-auto px-4 text-center relative z-10 bg-primary rounded-2xl py-1">
            <div className="inline-flex items-center justify-center p-4 bg-white/10 backdrop-blur rounded-full mb-8 border border-white/20">
              <UserGroupIcon className="w-12 h-12 text-secondary" />
            </div>

            <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-8 tracking-tight leading-tight">
              Parent <span className="text-secondary">Portal</span>
            </h1>

            <p className="text-xl md:text-2xl text-white/80 font-light mx-auto mb-6 leading-relaxed">
              The Parent Portal is your NYC Schools Account, hosted by NYC Public Schools.
              Sign in there to see your child's school information.
            </p>

            <p className="text-white/70 mb-12 leading-relaxed">
              The link below opens schoolsaccount.nyc in a new tab. If you need help signing in,
              please contact the school and we will be glad to walk you through it.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href={PORTAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-orange-700 hover:bg-orange-800 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-[0_0_20px_rgba(244,101,36,0.3)] hover:shadow-[0_0_30px_rgba(244,101,36,0.5)] hover:-translate-y-1 flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
              >
                Open the Parent Portal
                <ArrowTopRightOnSquareIcon className="w-5 h-5" aria-hidden="true" />
                <span className="sr-only">(opens in a new tab)</span>
              </a>
              <a
                href="/contact"
                className="bg-white hover:bg-gray-100 text-primary px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
              >
                Contact the School
              </a>
            </div>
          </div>
          <LionsStripe className="absolute inset-x-0 bottom-0 z-10" />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ParentPortalPage;
